// Canonical KYC status values — source of truth is sprout-loans-partner-api
// Partner.Loan.Common/Enums/KycStatus.cs. The FE enum previously had
// Completed = 2, which actually means InProgress on the backend; b.ii.2.1
// corrects this. Do not re-point these values without updating the backend.
export enum KycStatus {
  NotStarted = 1,
  InProgress = 2,
  Failed = 3,
  Rejected = 4,
  Approved = 5,
  Expired = 6,
  Declined = 7,
  Cancelled = 8,
  Completed = 9,
}

export interface KycResponse {
  statusId: KycStatus;
  cooldownCompletionDate?: string | null;
  rejectionDate?: string | null;
  rejectionReason?: string | null;
}

// Document-type values the backend maps to partner document names — source of
// truth is Partner.Loan.Business/LoanPartners/Netbank/Kyc/Models/
// NetBankDocumentType.cs (`FromId` throws for anything outside 1–3).
export enum KycDocumentType {
  LegalId = 1,
  Photo = 2,
  Signature = 3,
}

// A single KYC document submitted with the multipart PUT KYC request.
// `issuerName`/`countryCode` are accepted by the backend contract
// (sprout-loans `CreateKycDocumentDto` still declares both) but are NOT read
// when the partner upload is built: NetbankKycPartnerService derives the
// issuer from `LegalIdTypePartner.OutboundIssuer` via ResolveIssuerAsync,
// which is documented there as never trusting the caller's IssuerName, and
// sends the hardcoded `IssuingCountryCode = "PH"` for the country. They are
// dead weight on the wire from either client; this form sends neither.
export interface IKycDocument {
  documentTypeId: KycDocumentType;
  legalIdTypeId: number;
  documentIdNumber: string;
  file: File;
  issuerName?: string;
  countryCode?: string;
}

// Netbank's shape for the `details` form field. The backend deserializes this
// into NetbankKycUploadDetailsRequestDto(string CustomerId) and forwards
// CustomerId to Netbank — it is NOT a carrier for the KYC form fields, which
// travel via PATCH Borrower and POST/PUT addresses instead.
export interface INetbankKycDetails {
  customerId: string;
}

// Typed payload for submitKyc; the client assembles the multipart FormData.
export interface IKycSubmitRequest {
  // Partner-specific JSON string (the `details` form field).
  details: string;
  borrowerId: number;
  documents: IKycDocument[];
}
